import { ApiCollectionResponse, GetCollectionQueryParams } from '../../types';
import { ServiceAccount } from '@tinct/core-api-models';
import { ApiError, tinctApi } from '../../api';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';

type GetServiceAccountsStaticParams = {
  organizationId: string;
};

export type GetServiceAccountsParams = GetCollectionQueryParams<
  ServiceAccount,
  GetServiceAccountsStaticParams
>;

export const getServiceAccounts = async (
  params: GetServiceAccountsParams,
): Promise<ApiCollectionResponse<ServiceAccount>> => {
  return await tinctApi.serviceAccounts.getServiceAccounts(params);
};

export const useGetServiceAccounts = (
  params: GetServiceAccountsParams,
  options?: Omit<
    UseQueryOptions<ApiCollectionResponse<ServiceAccount>, ApiError>,
    'queryKey'
  >,
) =>
  useQuery({
    queryKey: ['service-accounts', params.staticParams?.organizationId, params],
    queryFn: () => getServiceAccounts(params),
    ...options,
  });
